import React, { memo, useState } from "react";
import CommonButton from "../Button/CommonButton";
import { useTheme } from "@material-ui/core/styles";
import { Block, Done } from "@material-ui/icons";
import Popup from "./Popup";

const ConfirmPopup = (props) => {
  const {
    open,
    title = "Xác nhận",
    textConfirm = "Xác nhận",
    textClose = "Hủy",
    text,
    onClose,
    onConfirm,
    isNotAPromise,
    size = "sm",
    textConfirmButtonSecond = null,
    onConfirmButtonSecond,
    hideConfirm = false,
  } = props;

  const [isDisable, setIsDisable] = useState(false);

  const theme = useTheme();
  return (
    <Popup
      open={open}
      title={title}
      handleClose={onClose}
      size={size}
      action={
        <>
          <CommonButton className="btn-gray mr-1" onClick={onClose}>
            <Block className="mr-2" />
            {textClose}
          </CommonButton>
          {!hideConfirm && (
            <CommonButton
              disabled={isDisable}
              onClick={() => {
                setIsDisable(true);
                if (isNotAPromise) {
                  onConfirm();
                  setIsDisable(false);
                } else onConfirm()?.finally(() => setIsDisable(false));
              }}
              className="btn-danger"
            >
              <Done className="mr-2" />
              {textConfirm}
            </CommonButton>
          )}
          {textConfirmButtonSecond && (
            <CommonButton
              disabled={isDisable}
              onClick={() => {
                setIsDisable(true);
                if (isNotAPromise) {
                  onConfirmButtonSecond();
                  setIsDisable(false);
                } else onConfirm().finally(() => setIsDisable(false));
              }}
              className="btn-danger"
            >
              {/* <Done className="mr-2" /> */}
              {textConfirmButtonSecond}
            </CommonButton>
          )}
        </>
      }
    >
      <h4 className="text-confirm">
        {typeof text === "function" ? text() : text}
      </h4>
    </Popup>
  );
};

export default memo(ConfirmPopup);
